import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { UntypedFormControl, UntypedFormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { UserService } from '../..';
import { MatButton } from '@angular/material/button';
import { NgIf } from '@angular/common';
import { MatInput } from '@angular/material/input';
import { MatFormField, MatError } from '@angular/material/form-field';
import { FlexModule } from '@angular/flex-layout';

@Component({
    selector: 'reset-password-dialog',
    templateUrl: './reset-password-dialog.component.html',
    styleUrls: ['./reset-password-dialog.component.css'],
    providers: [UserService],
    standalone: true,
    imports: [MatDialogTitle, ReactiveFormsModule, MatDialogContent, FlexModule, MatFormField, MatInput, NgIf, MatError, MatDialogActions, MatButton]
})
export class ResetPasswordDialogComponent {
  newPasswordForm = new UntypedFormGroup({
    password: new UntypedFormControl('', Validators.required),
    password_confirmed: new UntypedFormControl('', Validators.required)
  });
  userId: number;

  constructor(
    public dialogRef: MatDialogRef<ResetPasswordDialogComponent>,
    private userService: UserService,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    this.userId = data.userId;
    this.newPasswordForm.controls['password_confirmed'].valueChanges.subscribe(
      (value) => {
        if (
          value &&
          this.newPasswordForm.value.password &&
          value !== this.newPasswordForm.value.password
        ) {
          this.newPasswordForm.controls['password_confirmed'].setErrors({
            passwordMismatch: true
          });
        }
      }
    );
  }

  save() {
    if (this.newPasswordForm.valid) {
      this.userService
        .update(this.userId, this.newPasswordForm.value)
        .subscribe(() => {
          this.dialogRef.close();
        });
    }
  }
}
